// Mock data for Inżynieria Elektryczna Adrian Nowak clone

export const NAV_LINKS = [
  { label: 'Usługi', href: '#uslugi' },
  { label: 'Automatyka', href: '#automatyka' },
  { label: 'Nadzór', href: '#nadzor' },
  { label: 'Projektowanie', href: '#projektowanie' },
  { label: 'Obszar działania', href: '#obszar' },
  { label: 'Współpraca', href: '#partnerzy' },
  { label: 'O firmie', href: '#o-firmie' },
  { label: 'Kontakt', href: '#kontakt' },
];

export const MARQUEE_ITEMS = [
  'Automatyka przemysłowa',
  'Projektowanie elektryczne',
  'Kierowanie robotami',
  'Nadzór inwestorski',
  'Doradztwo techniczne',
  'Wyceny i audyty',
];

export const SERVICE_CARDS = [
  {
    letter: 'A',
    title: 'Automatyka przemysłowa',
    desc: 'Projektowanie układów sterowania, dobór aparatury i doradztwo dla maszyn oraz linii produkcyjnych.',
  },
  {
    letter: 'B',
    title: 'Nadzór i kierowanie robotami',
    desc: 'Kierownik robót, inspektor nadzoru inwestorskiego, odbiory i weryfikacja techniczna, bez ograniczeń.',
  },
  {
    letter: 'C',
    title: 'Projektowanie i konsultacje',
    desc: 'Projekty instalacji elektrycznych, weryfikacja dokumentacji oraz ekspertyzy techniczne.',
  },
];

export const AUTOMATION_ITEMS = [
  {
    title: 'Projektowanie układów automatyki i sterowania',
    desc: 'Tworzenie kompletnych projektów i schematów elektrycznych dla maszyn, linii produkcyjnych oraz procesów technologicznych wraz z doborem aparatury.',
    tags: ['aparatura modułowa', 'sterowniki PLC', 'czujniki', 'elementy wykonawcze', 'urządzenia automatyki'],
  },
  {
    title: 'Doradztwo techniczne i koncepcje',
    desc: 'Analiza potrzeb produkcyjnych, dobór rozwiązań automatyzacji, modernizacja istniejącego parku maszynowego oraz optymalizacja procesów technologicznych.',
  },
  {
    title: 'Wyceny i szacowanie kosztów',
    desc: 'Przygotowywanie wycen budżetowych, kosztorysów i specyfikacji technicznych dla planowanych inwestycji w zakresie automatyki i sterowania.',
  },
];

export const OVERSIGHT_ITEMS = [
  {
    title: 'Kierownik robót elektrycznych',
    desc: 'Pełnienie funkcji kierownika robót w specjalności elektrycznej na budowach oraz obiektach przemysłowych, komercyjnych i użyteczności publicznej.',
    bullets: [
      'prowadzenie dokumentacji budowlanej',
      'kontrola jakości',
      'kontrola zgodności prac z projektem',
      'zgodność z przepisami i wymaganiami technicznymi',
    ],
  },
  {
    title: 'Inspektor nadzoru inwestorskiego',
    desc: 'Reprezentowanie inwestora na budowie, weryfikacja poprawności montażu instalacji elektrycznych i elektroenergetycznych, kontrola prac oraz udział w odbiorach.',
  },
  {
    title: 'Odbiory i weryfikacja techniczna',
    desc: 'Udział w odbiorach technicznych, sprawdzanie dokumentacji powykonawczej, audyty oraz ocena stanu technicznego istniejących instalacji i sieci.',
  },
];

export const DESIGN_ITEMS = [
  {
    icon: 'PenTool',
    title: 'Projektowanie instalacji elektrycznych',
    desc: 'Opracowywanie projektów budowlanych i wykonawczych instalacji elektrycznych i elektroenergetycznych zgodnie z zakresem posiadanych uprawnień.',
  },
  {
    icon: 'FileSearch',
    title: 'Weryfikacja i sprawdzanie projektów',
    desc: 'Techniczna weryfikacja gotowych projektów branży elektrycznej pod kątem poprawności, bezpieczeństwa, optymalizacji rozwiązań i zgodności z wymaganiami.',
  },
  {
    icon: 'ClipboardCheck',
    title: 'Ekspertyzy techniczne',
    desc: 'Opinie i ekspertyzy dotyczące instalacji elektrycznych oraz układów zasilania w obiektach przemysłowych i budowlanych.',
  },
];

export const AUDIENCE = [
  { icon: 'FileText', title: 'Inwestorzy', desc: 'Wsparcie techniczne przy planowaniu, realizacji i odbiorze inwestycji.' },
  { icon: 'HardHat', title: 'Generalni wykonawcy', desc: 'Kierowanie i nadzór nad robotami elektrycznymi.' },
  { icon: 'Factory', title: 'Zakłady przemysłowe', desc: 'Automatyka, modernizacje, doradztwo i optymalizacja.' },
  { icon: 'ClipboardList', title: 'Kierownicy budów', desc: 'Wsparcie branży elektrycznej na etapie realizacji.' },
  { icon: 'PencilRuler', title: 'Projektanci', desc: 'Weryfikacja dokumentacji oraz konsultacje techniczne.' },
];

export const PROBLEMS = [
  { n: '01', title: 'Planujesz nową linię produkcyjną?', desc: 'Wsparcie w zakresie automatyki, sterowania, doboru aparatury i przygotowania koncepcji.' },
  { n: '02', title: 'Potrzebujesz osoby odpowiedzialnej za roboty elektryczne?', desc: 'Kierowanie robotami oraz nadzór w zakresie posiadanych uprawnień.' },
  { n: '03', title: 'Masz projekt i chcesz go zweryfikować?', desc: 'Techniczna analiza dokumentacji i wskazanie potencjalnych problemów.' },
  { n: '04', title: 'Nie wiesz, ile będzie kosztować inwestycja?', desc: 'Wycena budżetowa i przygotowanie zakresu technicznego.' },
  { n: '05', title: 'Modernizujesz istniejący zakład?', desc: 'Doradztwo dotyczące automatyzacji i modernizacji infrastruktury.' },
];

export const AREA_CHIPS = ['Polska', 'Promień 50 km', 'Cały kraj'];

export const PARTNERS = [
  { name: 'Hydro-Partner Sp. z o.o.', url: 'https://hydro-partner.pl/' },
  { name: 'D.D. Champ Sp. z o.o.', url: 'https://www.ddchamp.pl/index.php?lang=pl' },
  { name: 'INOXTRADING Grzegorz Litwiński', url: 'http://www.inoxtrading.eu/' },
  { name: 'MELBUD I Sp. z o.o. Sp. Komandytowa', url: 'https://www.melbud.com.pl/' },
];

export const LOGOS = {
  main: process.env.PUBLIC_URL + '/images/logo-main.webp',
  horizontal: process.env.PUBLIC_URL + '/images/logo-horizontal.png',
  sticker: process.env.PUBLIC_URL + '/images/logo-sticker.webp',
};

export const ABOUT_BULLETS = [
  'Indywidualne podejście do inwestycji',
  'Odpowiedzialność za jakość i zgodność prac',
  'Kompetencje inżynieryjne poparte uprawnieniami',
  'Znajomość realiów placu budowy i produkcji',
  'Połączenie automatyki z branżą elektryczną',
];

export const FAQS = [
  { q: 'Czy realizujesz nadzór nad robotami elektrycznymi w Lesznie?', a: 'Tak, świadczę usługi nadzoru inwestorskiego oraz kierowania robotami elektrycznymi w Lesznie i całym powiecie leszczyńskim. Obszar działania obejmuje również okoliczne miejscowości w promieniu około 50 km od Włoszakowic.' },
  { q: 'Czy możesz pełnić funkcję kierownika robót elektrycznych?', a: 'Tak, posiadam uprawnienia budowlane bez ograniczeń w specjalności instalacyjnej w zakresie sieci, instalacji i urządzeń elektrycznych i elektroenergetycznych, uprawniające do kierowania robotami budowlanymi.' },
  { q: 'Czy posiadasz uprawnienia budowlane bez ograniczeń?', a: 'Tak, moje uprawnienia budowlane są bez ograniczeń w zakresie projektowania oraz kierowania robotami budowlanymi w specjalności instalacyjnej elektrycznej.' },
  { q: 'Czy obsługujesz inwestycje przemysłowe?', a: 'Tak, obsługuję inwestycje przemysłowe zarówno w zakresie projektowania i konsultacji, jak i realizacji, kierowania robotami oraz nadzoru inwestorskiego.' },
  { q: 'Czy realizujesz projekty automatyki przemysłowej?', a: 'Tak, projektuję układy sterowania, dobieram aparaturę oraz przygotowuję kompletne projekty automatyki dla maszyn i linii produkcyjnych.' },
  { q: 'Czy wykonujesz wyceny projektów automatyki?', a: 'Tak, przygotowuję wyceny budżetowe, kosztorysy oraz specyfikacje techniczne dla planowanych inwestycji z zakresu automatyki.' },
  { q: 'Czy możesz zweryfikować istniejący projekt elektryczny?', a: 'Tak, wykonuję techniczną weryfikację i sprawdzenie gotowych projektów branży elektrycznej pod kątem poprawności, bezpieczeństwa oraz optymalizacji rozwiązań.' },
  { q: 'Czy świadczysz usługi poza Włoszakowicami?', a: 'Tak, usługi nadzorcze i wykonawcze realizuję głównie w regionie do około 50 km od Włoszakowic, natomiast projektowanie, wyceny i doradztwo świadczę na terenie Wielkopolski i Dolnego Śląska.' },
  { q: 'Czy możliwa jest współpraca z klientem z innej części Polski?', a: 'Tak, w zakresie projektowania, konsultacji, wycen, doradztwa technicznego, a także realizacji, kierowania robotami oraz nadzoru inwestorskiego możliwa jest współpraca z klientami z każdej części Polski.' },
  { q: 'Czy możesz doradzić w zakresie doboru aparatury i sterowników?', a: 'Tak, świadczę doradztwo techniczne w zakresie doboru aparatury modułowej, sterowników PLC, czujników oraz elementów wykonawczych do konkretnych zastosowań.' },
];

export const IMAGES = {
  hero: process.env.PUBLIC_URL + '/images/hero.jpg',
  automation: process.env.PUBLIC_URL + '/images/automation.jpg',
  oversight: process.env.PUBLIC_URL + '/images/oversight.jpg',
  about: process.env.PUBLIC_URL + '/images/about.jpg',
  polandMap: process.env.PUBLIC_URL + '/images/poland-map.png',
};

export const CONTACT = {
  phone: '661 349 935',
  phoneRaw: '+48661349935',
  email: 'biuro@ie-online.pl',
  google: 'https://maps.app.goo.gl/Yn9A2TvMBQTNWSjg8',
};
